module.exports = __webpack_public_path__ + "img/clicksTransit.145ea032.svg";